import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scroll by pixel amount
export const scrollByPixels = (pixels, behavior = 'smooth') => {
  window.scrollTo({
    top: window.pageYOffset + pixels,
    left: 0,
    behavior: behavior
  });
};

// Scroll by percentage of viewport height
export const scrollByPercentage = (percentage, behavior = 'smooth') => {
  const viewportHeight = window.innerHeight;
  const scrollAmount = (viewportHeight * percentage) / 100;
  window.scrollTo({
    top: window.pageYOffset + scrollAmount,
    left: 0,
    behavior: behavior
  });
};

// Scroll to specific percentage of page
export const scrollToPagePercentage = (percentage, behavior = 'smooth') => {
  const documentHeight = document.documentElement.scrollHeight;
  const scrollAmount = (documentHeight * percentage) / 100;
  window.scrollTo({
    top: scrollAmount,
    left: 0,
    behavior: behavior
  });
};

// Original scroll to top function
export const scrollToTop = (behavior = 'smooth') => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: behavior
  });
};

// Component that watches route changes
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollToTop();
  }, [pathname]);

  return null;
}

export default ScrollToTop;

// Examples of usage:

// Scroll down 100 pixels
// scrollByPixels(100);

// Scroll up 100 pixels
// scrollByPixels(-100);

// Scroll down by 20% of viewport height
// scrollByPercentage(20);

// Scroll up by 20% of viewport height
// scrollByPercentage(-20);

// Scroll to 50% of the page
// scrollToPagePercentage(50);

// Scroll to top (original functionality)
// scrollToTop();

// You can also specify the behavior
// scrollByPixels(100, 'auto'); // 'auto' for instant scroll
// scrollByPercentage(20, 'smooth'); // 'smooth' for smooth animation
